import React, { memo, useEffect, useRef, useState } from 'react';
import { PageContext, KView, KText, KImage } from '@/component/RtlLayout';
import { convertStyles } from '@kibt/krn-utils';
import { View, useWindowDimensions, Text, TouchableHighlight } from 'react-native';
import { $k18n } from '@/common/i18n';
import RenderHtml, { Element } from 'react-native-render-html';

import SrcStyles from './index.styl';
import LinearGradient from 'react-native-linear-gradient';
import { isMobileDeviceValue, windowWidth } from '@/common/device-info';
import arrowBlack from '@/assets/icon_detail/iconArrowBlack.png';
import { useDetailPageStore } from '@/page/detail/store';
import { ViewVisible } from '@/component/ViewVisible/ViewVisible';
import { logClickViewMoreButton, logShowViewMoreButton } from '../../../logger2.0';
import { useDetailLogger } from '../../../logger3.0';
const Styles = convertStyles(SrcStyles);

function scaleImg(element: Element) {
    if (element?.name === 'img') {
        const w = +(element?.attribs?.width || '');
        const h = +(element?.attribs?.height || '');
        if (w) {
            let parentWidth = windowWidth;

            if (element.parent?.name === 'li') {
                parentWidth = windowWidth - 30;
            }
            const newW = parentWidth * 0.9;
            element.attribs.width = `${Math.floor(newW)}`;
            element.attribs.height = `${Math.floor(newW * (h / w))}`;
        }
    }
}
function RenderDetail() {
    const { width } = useWindowDimensions();
    const { detail, abTest } = useDetailPageStore(s => ({
        detail: s.pageRawData?.detail,
        abTest: s.pageRawData?.abTest,
    }));

    const { logItemDesc } = useDetailLogger();

    const tagsStyles = {
        ol: {
            // listStyleType: 'none',
            // padding: 0,
        },
        img: {
            // width: '90%',
            // height: 'auto',
        },
    };
    const renderersProps = {
        img: {
            enableExperimentalPercentWidth: true,
        },
    };

    // 如果包含图片，则保留当前线上逻辑，高于315的时候收起; 如果不包含图片，则在高于230的时候收起
    // 多设置40的高度，防止加上more按钮后还比之前的高度高
    const limitHeight = detail.includes(`<img src=`) ? 355 : 270;

    const [detailInfoState, setDetailInfoState] = useState({
        detailInfoStyle: {
            maxHeight: limitHeight + 1,
            overflow: 'hidden',
            position: 'relative',
        } as any,
        detailPanelStyle: {
            opacity: 0,
        },
        showMore: false,
    });

    useEffect(() => {
        if (!abTest?.ifProductDetailsReco) {
            setDetailInfoState(pre => ({
                detailPanelStyle: {
                    opacity: 1,
                },
                detailInfoStyle: {},
                showMore: false,
            }));
        }
    }, [abTest?.ifProductDetailsReco]);

    // 点击一次「show more」之后就不可再点击
    const showMoreChanged = useRef(false);
    const detailInit = useRef(false);

    return (
        <PageContext.Provider value={{ Styles }}>
            {detail ? (
                <ViewVisible onVisible={() => logItemDesc()}>
                    <KView
                        rtlClassName={'product-detail-wrapper'}
                        style={[
                            {
                                paddingLeft: 16,
                                paddingRight: 16,
                                paddingTop: 20,
                                paddingBottom: 0,
                            },
                            detailInfoState.detailPanelStyle,
                        ]}
                        onLayout={event => {
                            if (!abTest?.ifProductDetailsReco) return;
                            // 第一次加载商品详情时，设置为透明，判断高度，如果高度超过limitHeight + 1，则收起详情并展示「显示更多」
                            const height = Math.floor(event.nativeEvent.layout.height || 0);
                            console.log('limitHeight', limitHeight, height);
                            if (!detailInit.current) {
                                if (height > limitHeight) {
                                    setDetailInfoState(pre => ({
                                        ...pre,
                                        showMore: true,
                                        detailPanelStyle: {} as any,
                                    }));
                                } else
                                    setDetailInfoState(pre => ({
                                        ...pre,
                                        showMore: false,
                                        detailPanelStyle: {} as any,
                                    }));
                                detailInit.current = true;
                            }
                        }}>
                        <KView rtlClassName={'product-detail-title'}>
                            <KText rtlClassName={'product-detail-title-text'}>{$k18n('商品描述')}</KText>
                        </KView>
                        <View>
                            <KView rtlClassName={'product-detail-desc'} style={detailInfoState.detailInfoStyle}>
                                <View>
                                    <RenderHtml
                                        contentWidth={isMobileDeviceValue ? width : 414}
                                        tagsStyles={tagsStyles}
                                        baseStyle={{ color: '#000' }}
                                        source={{ html: detail }}
                                        renderersProps={renderersProps}
                                        domVisitors={{
                                            onElement(element) {
                                                scaleImg(element);
                                            },
                                        }}
                                    />
                                </View>
                                {detailInfoState.showMore ? (
                                    <LinearGradient
                                        // 定义渐变的起止颜色
                                        colors={['rgba(255,255,255,0)', 'rgba(255,255,255,1)']}
                                        // 定义渐变的方向
                                        start={{ x: 0, y: 0 }}
                                        end={{ x: 0, y: 1 }}
                                        style={{"position":"absolute","bottom":"0rem","left":"0rem","width":"100.00000000000001rem","height":"24.154589371980677rem","justifyContent":"center","alignItems":"center"}}
                                    />
                                ) : null}
                            </KView>
                            {detailInfoState.showMore ? (
                                <TouchableHighlight
                                    onPress={() => {
                                        logClickViewMoreButton();
                                        showMoreChanged.current = true;
                                        setDetailInfoState(pre => ({
                                            ...pre,
                                            showMore: false,
                                            detailInfoStyle: {
                                                position: 'relative',
                                            } as any,
                                        }));
                                    }}
                                    underlayColor="transparent">
                                    <ViewVisible onVisible={logShowViewMoreButton}>
                                        <View
                                            style={{"alignItems":"center","justifyContent":"center","height":"9.66183574879227rem","flexDirection":"row"}}>
                                            <Text
                                                style={{"lineHeight":"3.8647342995169085rem","fontSize":"2.8985507246376816rem"}}>
                                                {$k18n({ id: 'k_895667', text: '全部' })}
                                            </Text>
                                            <KImage
                                                source={arrowBlack}
                                                style={{"height":"3.8647342995169085rem","width":"3.8647342995169085rem"}}
                                            />
                                        </View>
                                    </ViewVisible>
                                </TouchableHighlight>
                            ) : null}
                        </View>
                    </KView>
                </ViewVisible>
            ) : null}
        </PageContext.Provider>
    );
}
export default memo(RenderDetail);
